import { useState, useMemo } from "react";
import { toast } from "react-toastify";
import { MdOutlineLocalOffer } from "react-icons/md";
import useProduct from "../../../marketplace_admin/libs/useProduct";
import useSetHotDeal from "../../../marketplace_admin/libs/useSetHotDeal";
import useSetTrendingDeal from "../../../marketplace_admin/libs/useSetTrendingDeal";
import useSetTodaysDeal from "../../../marketplace_admin/libs/useSetTodaysDeal";
import PageHeader from "../../components/PageHeader";
import FilterBar from "../../components/FilterBar";
import DataTable from "../../components/DataTable";

const AdminDealsPage = () => {
  const { data, isLoading } = useProduct();
  const [search, setSearch] = useState("");
  const { setHotDeal } = useSetHotDeal();
  const { setTrendingDeal } = useSetTrendingDeal();
  const { setTodaysDeal } = useSetTodaysDeal();

  const products = useMemo(() => {
    const all = data?.pages?.flatMap((p) => p.products) || [];
    if (!search) return all.slice(0, 50);
    return all.filter((p) => p.name.toLowerCase().includes(search.toLowerCase())).slice(0, 50);
  }, [data, search]);

  const runToggle = async (fn, id, label) => {
    try {
      await fn(id);
      toast.success(`${label} updated`);
    } catch {
      toast.error(`Failed to update ${label}`);
    }
  };

  const columns = [
    { key: "name", label: "Product" },
    {
      key: "hot",
      label: "Hot",
      render: (r) => (
        <button type="button" className="dashboard-btn dashboard-btn--secondary" onClick={() => runToggle(setHotDeal, r._id, "Hot deal")}>
          {r.isHotDeal ? "On" : "Off"}
        </button>
      ),
    },
    {
      key: "trending",
      label: "Trending",
      render: (r) => (
        <button type="button" className="dashboard-btn dashboard-btn--secondary" onClick={() => runToggle(setTrendingDeal, r._id, "Trending")}>
          {r.isTrending ? "On" : "Off"}
        </button>
      ),
    },
    {
      key: "today",
      label: "Today",
      render: (r) => (
        <button type="button" className="dashboard-btn dashboard-btn--secondary" onClick={() => runToggle(setTodaysDeal, r._id, "Today deal")}>
          {r.isTodaysDeal ? "On" : "Off"}
        </button>
      ),
    },
  ];

  return (
    <>
      <PageHeader title="Deals hub" subtitle="Manage trending, hot, and today deals" icon={MdOutlineLocalOffer} />
      <FilterBar searchValue={search} onSearchChange={setSearch} searchPlaceholder="Search products…" />
      <DataTable columns={columns} rows={products.map((p) => ({ ...p, _key: p._id }))} loading={isLoading} />
    </>
  );
};

export default AdminDealsPage;
